import ReasonFilterBar from '../ReasonFilterBar';
import ReasonList from '../ReasonList';

import ReasonHeader from './ReasonHeader';
import ReasonLayout from './ReasonLayout';
import useReasonReport from './hooks';

const ReasonPage = () => {
  const { reasonReports, isLoading } = useReasonReport();

  return (
    <ReasonLayout>
      <div>
        <ReasonHeader />
        <ReasonFilterBar />
      </div>
      <ReasonList reasonReports={reasonReports} loading={isLoading} />
    </ReasonLayout>
  );
};

export default ReasonPage;
